import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/service-type";

export const getAllServiceType = () => axios.get(API_PATH + "/getAll");

export const pagingServiceType = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getServiceTypeById = (serviceTypeId) => axios.get(API_PATH + "/getbyid/" + serviceTypeId);

export const saveOrUpdateServiceType = serviceType => axios.post(API_PATH + "/save", serviceType);

export const deleteServiceType = serviceTypeId => axios.delete(API_PATH + '/mark-delete/' + serviceTypeId);
